//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HeartIcon24px',
  props: {
    pathClass: {
      type: String,
      default: ''
    }
  }
};
